module.exports = __webpack_public_path__ + "img/LJ.6a777123.jpg";